import { SYSTEM_ERROR } from "../config/CONSTANTS";
import {
  TRIGGER_ONBOARDING_INVENTORY_ORDER_JOB,
  GET_ONBOARDING_INVENTORY_ORDER_JOB_STATUS,
  GET_LAST_SYNC_STATUS,
  TRIGGER_MANUAL_ORDER_INVENTORY_SYNC_JOB,
  GET_ONGOING_SYNC_JOB_STATUS,
  UPDATE_SHOP_ONBOARDING_STATUS,
} from "./CONSTANTS";
import axiosInstance from "../utils/axiosInstance";

//GET API call to get the status of the ongoing sync order inventory job
export const getOngoingSyncJobStatus = () => {

  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(GET_ONGOING_SYNC_JOB_STATUS())
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("Error in getOngoingSyncJobStatus Axios!");
        });
    } catch (error) {
      console.error(
        "in jobTriggerService > getOngoingSyncJobStatus, Err===",
        error
      );
      reject(SYSTEM_ERROR);
    }
  });
};

//GET API call to check running job
export const triggerOrderInventoryManualSync = () => {

  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(TRIGGER_MANUAL_ORDER_INVENTORY_SYNC_JOB())
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("Error in triggerOrderInventoryManualSync Axios!");
        });
    } catch (error) {
      console.error(
        "in jobTriggerService > triggerOrderInventoryManualSync, Err===",
        error
      );
      reject(SYSTEM_ERROR);
    }
  });
};

//POST API call to trigger onboarding sync inventory and order for 7 and 60days
export const callOnboardingInventoryOrderSync = (dataObj) => {

  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(TRIGGER_ONBOARDING_INVENTORY_ORDER_JOB(), dataObj)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("Error in callOnboardingInventoryOrderSync Axios!");
        });
    } catch (error) {
      console.error(
        "in jobTriggerService > callOnboardingInventoryOrderSync, Err===",
        error
      );
      reject(SYSTEM_ERROR);
    }
  });
};

//GET API call to get the onboarding job status with 7daysStatus and 60daysStatus params
export const getOnboardingInventoryOrderSyncStatus = (statusType) => {

  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(`${GET_ONBOARDING_INVENTORY_ORDER_JOB_STATUS()}/${statusType}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("Error in getOnboardingInventoryOrderSyncStatus Axios!");
        });
    } catch (error) {
      console.error(
        "in jobTriggerService > getOnboardingInventoryOrderSyncStatus, Err===",
        error
      );
      reject(SYSTEM_ERROR);
    }
  });
};

//GET API call to get the onboarding job status with 7daysStatus and 60daysStatus params
export const getLastSyncStatusTimestamp = () => {

  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(GET_LAST_SYNC_STATUS())
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("Error in getLastSyncStatusTimestamp Axios!");
        });
    } catch (error) {
      console.error(
        "in jobTriggerService > getLastSyncStatusTimestamp, Err===",
        error
      );
      reject(SYSTEM_ERROR);
    }
  });
};

//updated shop onboarding status
export const updateShopOnboardingStatus = (userUpdateObj) => {

  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .put(UPDATE_SHOP_ONBOARDING_STATUS(), userUpdateObj)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("Error in Updating user information Axios!");
        });
    } catch (error) {
      console.error("in userServices > updateUserDetails, Err===", error);
      reject(SYSTEM_ERROR);
    }
  });
};
